import React from 'react';
import { getFullPath } from './useFieldValue';
import { GroupField } from './GroupField';

/**
 * Groups fields under a heading and nests their values under its own key.
 *
 * `group` is the other grouping type and renders identically; the two differ only in where the
 * children write, so this is a group rooted one level deeper.
 */
export const ObjectField = ({ basePath, field }) => (
  <GroupField basePath={getFullPath(basePath, field.key)} field={field} />
);

export default ObjectField;
